import { render } from "./TabsWrapper.vue?vue&type=template&id=a2c5e3b8&scoped=true"
import script from "./TabsWrapper.vue?vue&type=script&lang=js"
export * from "./TabsWrapper.vue?vue&type=script&lang=js"

import "./TabsWrapper.vue?vue&type=style&index=0&id=a2c5e3b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a2c5e3b8"

export default script